<template>
  <v-container>
    <component :is="getRicambiComponent" />
  </v-container>
</template>

<script>
  import { mapGetters, mapMutations } from 'vuex'

  import Index from './../components/magazzino/replacements/Index'
  import Insert from './../components/magazzino/replacements/Insert'

  export default {
    name: 'MagazzinoRicambi',
    components: {
      Index,
      Insert
    },
    computed: {
      ...mapGetters([
        'getRicambiComponent'
      ])
    },
    methods: {
      ...mapMutations([
        'CHANGE_RICAMBI_COMPONENT'
      ])
    },
    destroyed() {
      this.CHANGE_RICAMBI_COMPONENT('Index')
    }
  }
</script>

<style>
</style>